module.exports = __webpack_public_path__ + "media/images/home_header_bg-a94c511148c14de647216e8ad2b88549.jpg";